import React from 'react'
import { Dispatch, SetStateAction, createContext } from 'react'

export function useFinanceDrawerContext() {
  const context = React.useContext(FinanceDrawerContext)

  return context
}

export const FinanceDrawerContext = createContext<
  { setIsShowingFinanceDrawer: Dispatch<SetStateAction<boolean>> } | undefined
>(undefined)
